<template>
  <div class="row no-gutters">
    <div class="form-group col-md-3 px-1">
      <v-autocomplete :items="locationsLocal" v-model="query.where" :get-label="getLocationLabel" :min-len="0"
                      :input-attrs="inputAttrs" :component-item="template" @update-items="updateLocations" @focus="loadLocations">
      </v-autocomplete>
    </div>
    <div class="form-group col-md-3 px-1">
      <datepicker v-model="query.when" placeholder="Kada putujem" input-class="form-control form-control-lg"
                  start-view="days" start-date="today"></datepicker>
    </div>
    <div class="form-group col-md-3 px-1">
      <multiselect v-model="query.what" :options="options" :multiple="true" label="name" track-by="name"
                   :searchable="false" :hide-selected="true" :close-on-select="false" select-label=""
                   placeholder="Vrsta putovanja"></multiselect>
    </div>
    <div class="col-md-3 px-1">
      <button type="button" class="btn btn-primary btn-lg btn-block" @click="submit($event)">Pronađi</button>
    </div>
  </div>
</template>

<script>
import Datepicker from './Datepicker.vue'
import Multiselect from 'vue-multiselect'
import Autocomplete from 'v-autocomplete'
import AutocompleteItem from './partials/AutocompleteItem.vue'

export default {
  components: {
    Multiselect,
    Datepicker,
    'v-autocomplete': Autocomplete,
  },

  props: {
    selected: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },

  data() {
    return {
      template: AutocompleteItem,
      inputAttrs: {
        type: 'text',
        class: 'form-control form-control-lg',
        placeholder: 'Kamo putujem'
      },
      locationsLocal: [],
      query: {
        where: null,
        when: null,
        what: [],
      },
      locations: [],
      options: [],
      loaded: false
    }
  },

  computed: {
    validate: function () {
      if (!_.isNull(this.query.where) || !_.isNull(this.query.when) || !_.isEmpty(this.query.what)) {
        return true
      } else {
        return false
      }
    }
  },

  mounted() {

  },

  methods: {
    loadLocations() {
      if (this.loaded) return;

      axios.get('/podatci-pretrage')
          .then((response) => {
            this.locationsLocal = response.data.locations
            this.locations = response.data.locations
            this.options = response.data.options

            if (this.selected.location) {
              this.query.where = this.selected.location
            }

            if (this.selected.date) {
              this.query.when = this.selected.date
            }

            if (this.selected.types) {
              this.query.what = this.selected.types
            }
          })
          .catch(function (error) {
            console.log(error)
          })
    },

    getLocationLabel(item) {
      return item ? item.name : ''
    },

    updateLocations(q) {
      this.locationsLocal = this.locations.filter((item) => {
        return (new RegExp(q.toLowerCase())).test(item.name.toLowerCase())
      })
    },

    submit(e) {
      let btn = e.target

      btn.classList.add('active')
      btn.disabled = true

      if (this.validate === true) {
        let route = '/pretraga',
            params = ''

        if (!_.isNull(this.query.where)) {
          let paramData = `location=${this.query.where.code}`

          params += params == '' ? params += `?${paramData}` : `&${paramData}`
        }

        if (!_.isNull(this.query.when)) {
          let paramData = `date=${this.query.when}`

          params += params == '' ? params += `?${paramData}` : `&${paramData}`
        }

        if (!_.isEmpty(this.query.what)) {
          let paramDataItems = ''

          _.forEach(this.query.what, function (item) {
            paramDataItems += paramDataItems == '' ? item.key : `,${item.key}`
          })

          let paramData = `type=${paramDataItems}`

          params += params == '' ? params += `?${paramData}` : `&${paramData}`
        }

        route += params

        window.location.href = route

        btn.disabled = false
        btn.classList.remove('active')
      } else {
        btn.disabled = false
        btn.classList.remove('active')

        alert('Unesite barem jedan parametar pretrage!')
      }
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
